class UrlModules {
  constructor({
    module = ''
  }) {
    this.modules = {
      appgateway: {
        pix: `https://h5`,
        url: `.lifekh.com`
      },
      fileserver: {
        pix: `https://fileserver`,
        url: `.lifekh.com`
      }
    };
    if (!module) {
      throw `module is empty!`;
    }
    this.module = module;
    this.isDevelopment = process?.env?.NODE_ENV === 'development';
  }
  get env() {
    return this.isDevelopment && 'sit' || (window?.ssrConfig?.routerConfig?.env?.replace(/local|dev/g, 'sit') ?? 'sit');
  }
  /**
   * 根据模块名获取对应的域名
   * @param {'appgateway'} module
   */
  get host() {
    let envPix = '';
    if (this.env && this.env.toLocaleLowerCase() !== 'pro') {
      envPix = `-${this.env}`;
    }
    return `${this.modules[this.module].pix}${envPix}${this.modules[this.module].url}`;
    // return 'http://127.0.0.1:7001'
  }
}
export default UrlModules;
